export function isContent(selected_person_id, patient_person_id) {
  return selected_person_id !== null && selected_person_id !== patient_person_id
}
